import { css } from 'styled-components';
import motionCss from './motion.css';

export const motionTokens = css`
  ${motionCss}
`;
